import React from "react";
import "./What_Makes_Us_Special.css";
import { Row, Col } from "react-bootstrap";

const What_makes_Us_Special = () => {
  const cards = [
    {
      title: "Bicycles and Bikes",
      img: "/assets/images/eco_friendly/Bicycle.png",
    },
    {
      title: "Electric Vehicles",
      img: "/assets/images/eco_friendly/Electric_Vehicles.png",
    },
    {
      title: "Electric Rickshaw",
      img: "/assets/images/eco_friendly/Rickshaw.png",
    },
    {
      title: "Electric Tempo",
      img: "/assets/images/eco_friendly/Electric_Tempo.png",
    },
  ];

  return (
    <section className="wmus-section">
      <h2 className="wmus-title">What makes Us Special ?</h2>

      <div className="container">
        {/* Subtitle Row */}
        <div className="wmus-subtitle-row">
          <h3 className="wmus-subtitle">Eco-friendly Rides</h3>
          <div className="wmus-line"></div>
        </div>

        <Row className="row-justify-content-center g-0">
          {cards.map((item, index) => (
            <Col lg={3} xs={6} md={6} className="mb-3" key={index}>
              <div className="wmus-card">
                <h4 className="wmus-card-title">{item.title}</h4>
                <img
                  src={item.img}
                  alt={item.title}
                  className="wmus-card-img"
                />
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default What_makes_Us_Special;
